import axios from '@/user/axios.js'

const moduleAnalytics = {
  namespaced: true,
  state: {
    requestingStatus: {
      analytics: false,
      adSalesByAsinTitle: false,
      product: false
    },
    reportData: {
      analytics: [],
      adSalesByAsinTitle: [],
      product: {
        smallImage: '',
        title: '',
        brand: '',
        parentAsin: '',
        asin: '',
        sku: '',
        categoryName: '',
        subcategoryName: '',
        categorySr: '',
        subcategorySr: '',
        cost: 0
      }
    },
    fieldKeywordMap: {}
  },
  mutations: {
    SET_REQUESTING_STATUS (state, data) {
      state.requestingStatus = {
        ...state.requestingStatus,
        ...data
      }
    },
    SET_REPORT_DATA (state, data) {
      state.reportData = {
        ...state.reportData,
        ...data
      }
    },
    SET_FIELD_KEYWORD_DATA (state, data) {
      state.fieldKeywordMap = data
    }
  },
  actions: {
    fetchData (context, payload) {
      return new Promise(async (resolve, reject) => {
        context.commit('SET_REQUESTING_STATUS', {
          [payload.action]: true
        })
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/analytics/${sellerId}`, {
            params: payload
          })
          context.commit('SET_REQUESTING_STATUS', {
            [payload.action]: false
          })
          if (res.data.success) {
            if (payload.action === 'analytics') {
              context.commit('SET_REPORT_DATA', {
                [payload.action]: res.data.data.rows
              })
              context.commit('SET_FIELD_KEYWORD_DATA', res.data.data.fieldKeywordMap)
            } else {
              context.commit('SET_REPORT_DATA', {
                [payload.action]: res.data.data
              })
            }
          }
          resolve(res)
        } catch (err) {
          context.commit('SET_REQUESTING_STATUS', {
            [payload.action]: false
          })
          reject(err)
        }
      })
    }
  }
}

export default moduleAnalytics
